export default "__VITE_ASSET__BEHJM1jj__"